// extracted by mini-css-extract-plugin
export default {"staticPageWrapper":"ContactPage_staticPageWrapper__sQzfo","form":"ContactPage_form__PMRMC"};